import { useState, useEffect, useCallback } from "react";
import BreadCrumb from "../Controls/BreadCrumb";
import EmployerBrief from "../Views/EmployerBrief";
import Spinner from "../Controls/Spinner";
import EmployerRoleListItem from "../ListItems/EmployerRoleListItem";
import JobPostingListItem from "../ListItems/JobPostingListItem";
import JobPostingEditModal from "../Modals/JobPostingEditModal";
import Help from "../Controls/Help";
import { Link, useParams } from "react-router-dom";
import UserData from "../Controls/UserData";
import API from "@src/API.js";
import { MdAddBox } from "react-icons/md";
import EmployerManagementLocator from "./EmployerManagementLocator";

export default function EmployerView(props) {
   const { id } = useParams();
   const employerID = parseInt(id);

   const [admin, Update] = useState({ Admins: [] });
   const [lookups] = useState(() => UserData.Lookups() || {});
   const [processing, setProcessing] = useState(false);
   const [breadcrumb] = useState([]);
   const [jobPostingModalId, setJobPostingModalId] = useState(null);

   const loadAdmin = useCallback(async () => {
      if (!employerID) return;
      setProcessing(true);
      try {
         const resp = await API.getAsync("/Employer/" + employerID + "/Admin");
         if (resp && resp.ok) {
            Update(resp.jsonData);
         }
      } catch (error) {
         console.error("Error fetching employer data:", error);
      } finally {
         setProcessing(false);
      }
   }, [employerID]);

   useEffect(() => {
      loadAdmin();
   }, [loadAdmin]);

   const hasAdministrator = (admin.Admins || admin.admins || []).length > 0;

   return (
      <div>
         <BreadCrumb props={breadcrumb} />
         {!processing && !hasAdministrator ? (
            <EmployerManagementLocator
               employerId={employerID}
               onAssociated={loadAdmin}
            />
         ) : null}
         <div className="tabbody">
            <h1>Employer</h1>
            <div className="pageSection textCentered">
               <EmployerBrief ID={employerID} />
            </div>
            <div className="pageSection">
               <div className="tabsection">
                  <div className="listTitle">
                     <span>
                        Roles
                        <Help id="2120" />
                     </span>
                     <div className="listTitleIcons">
                        <Link
                           to={{
                              pathname: "/employerRoleEdit/0",
                              state: {
                                 breadcrumb: breadcrumb,
                                 employer: { ID: employerID, Name: admin.EmployerName },
                              },
                           }}
                        >
                           <MdAddBox />
                        </Link>
                     </div>
                  </div>
                  <div className="sectionData">
                     <ul>
                        {admin.Roles
                           ? admin.Roles.map((role) => (
                              <li key={role.id}>
                                 <EmployerRoleListItem
                                    employerID={employerID}
                                    employerName={admin.EmployerName}
                                    role={role}
                                    breadcrumb={breadcrumb}
                                    postings={admin.Postings}
                                    employmentTypes={lookups.employmentType || lookups.EmploymentType || []}
                                 />
                              </li>
                           ))
                           : ""}
                     </ul>
                  </div>
               </div>
               <div className="tabsection">
                  <div className="listTitle">
                     <span>
                        Job Postings
                        <Help id="2121" />
                     </span>
                     <div className="listTitleIcons">
                        <MdAddBox
                           data-testid="job-posting-add"
                           role="button"
                           aria-label="Add job posting"
                           onClick={() => setJobPostingModalId(0)}
                        />
                     </div>
                  </div>
                  <div className="sectionData">
                     <ul>
                        {admin.Postings
                           ? admin.Postings.map((jobPost) => (
                              <li key={jobPost.ID || jobPost.id}>
                                 <JobPostingListItem
                                    post={jobPost}
                                    employmentTypes={lookups.employmentType || lookups.EmploymentType || []}
                                    onEdit={(postId) => setJobPostingModalId(postId)}
                                 />
                              </li>
                           ))
                           : ""}
                     </ul>
                  </div>
               </div>
            </div>
         </div>
         <Spinner show={processing || props.processing} />
         {jobPostingModalId !== null ? (
            <JobPostingEditModal
               jobPostingId={jobPostingModalId}
               employerId={employerID}
               employerName={admin.EmployerName}
               roles={admin.Roles || []}
               packages={admin.Packages || []}
               onClose={async () => {
                  setJobPostingModalId(null);
                  await loadAdmin();
               }}
            />
         ) : null}
      </div>
   );
}
